import { useState, useEffect, useCallback } from "react";
import type { User } from "@/types/user";
import { supabase } from "@/libs/supabase";

interface UseUsersReturn {
	users: User[] | null;
	loading: boolean;
	error: string | null;
	refetch: () => Promise<void>;
}

export const useUsers = (): UseUsersReturn => {
	const [users, setUsers] = useState<User[] | null>(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState<string | null>(null);

	const fetchUsers = useCallback(async () => {
		try {
			setLoading(true);
			const { data, error: fetchError } = await supabase
				.from("users")
				.select("*")
				.order("created_at", { ascending: false });

			if (fetchError) throw fetchError;

			setUsers(data as User[]);
			setError(null);
		} catch (err) {
			console.error("ユーザー取得エラー:", err);
			setError("ユーザーの取得に失敗しました");
		} finally {
			setLoading(false);
		}
	}, []); // 依存配列は空でOK（supabaseクライアントは不変）

	useEffect(() => {
		fetchUsers();
	}, [fetchUsers]); // fetchUsersを依存配列に追加

	return {
		users,
		loading,
		error,
		refetch: fetchUsers,
	};
};
